export default "__VITE_PUBLIC_ASSET__3d6ddf4e__"